import React from "react";

interface LikeIconProps {
    width?: string;
    height?: string;
    fill?: string;
    stroke?: string;
    onClick?: () => void;
    className?: string;
}

const LikeIcon: React.FC<LikeIconProps> = ({
    width = "28",
    height = "28",
    fill = "none",
    stroke = "currentColor",
    onClick,
    className
}) => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.3191 7.45413C14.3191 6.99608 14.1378 6.55693 13.8153 6.23304C13.6193 6.03628 13.3808 5.89273 13.1216 5.80971L10.0195 12.8192V20.5968L12.7034 21.2706H17.7589C17.7751 21.2706 17.7914 21.2714 17.8076 21.2723C18.1798 21.2935 18.5488 21.1924 18.859 20.9848C19.1624 20.7816 19.3925 20.4865 19.5182 20.1432L21.2246 13.2897L21.2305 13.2669C21.2825 13.0799 21.2944 12.8782 21.2649 12.6817C21.2354 12.4852 21.166 12.3075 21.0701 12.1631C20.9744 12.019 20.8584 11.9162 20.7401 11.8527C20.6227 11.7899 20.5017 11.7637 20.3857 11.7701C20.37 11.771 20.3543 11.7718 20.3386 11.7718H15.1791C14.7041 11.7718 14.3191 11.3852 14.3191 10.9083V7.45413ZM5.71986 20.4071H8.29964V13.4988H5.71986V20.4071ZM16.039 10.0447H20.3386C20.7614 10.0299 21.1768 10.1291 21.5496 10.3289C21.9351 10.5355 22.2587 10.8401 22.5011 11.2051C22.7431 11.5698 22.9 11.9881 22.9655 12.4237C23.0297 12.8513 23.0039 13.2902 22.8916 13.7071L22.8924 13.708L21.1725 20.6162C21.1661 20.6423 21.1587 20.6685 21.1499 20.6938C20.9025 21.4001 20.4333 22.0065 19.8129 22.4217C19.2061 22.828 18.4867 23.0279 17.7589 22.9969V22.9977H12.5993C12.529 22.9977 12.4592 22.9886 12.391 22.9716L9.05544 22.1342H5.71986C5.26372 22.1342 4.8264 21.9521 4.50386 21.6282C4.18133 21.3043 4 20.8651 4 20.4071V13.4988C4 13.0408 4.18133 12.6016 4.50386 12.2778C4.8264 11.9539 5.26372 11.7718 5.71986 11.7718H8.60028L11.8133 4.51272L11.8729 4.40141C12.0289 4.15395 12.3019 4 12.5993 4C13.5116 4 14.3862 4.36418 15.0313 5.01195C15.6763 5.65973 16.039 6.53804 16.039 7.45413V10.0447Z" fill="currentColor" />
    </svg>


);

export default LikeIcon;
